﻿import {
    pageIsLoadingAction,
    pageLoadedAction,
    pageCurrentStepAction,
    pageHasErroredAction,
    pageErrorAction
} from '../../../State/actions';

import PensionCalculationService from '../Services/PensionCalculationService';

// forms

export function retirementGuideUpdateFormDataAction(formData) {
    return {
        type: 'RETIREMENT_GUIDE_UPDATE_FORM_DATA',
        formData
    };
}

// chart

export function retirementGuideUpdateChartAction() {
    const pensionCalculationService = new PensionCalculationService();

    const round = (value, precision = 100, floor = false) => floor
        ? Math.floor(parseFloat(value) / precision) * precision
        : Math.ceil(parseFloat(value) / precision) * precision;

    return (dispatch, getState) => {
        const { retirementGuideFormData } = getState();
        const retirementData = retirementGuideFormData.formData;
        const defaultRetirementAge = 65;

        const pensionData = pensionCalculationService.calculateTotalMonthlyPension(
            retirementData.startedWorkAge,
            retirementData.age,
            defaultRetirementAge,
            retirementData.monthlySalary,
            retirementData.wantedMonthlyPension,
            retirementData.occupationalPlan
        );


        const yScale = retirementData.monthlySalary > 60000 ? 10000 : 5000;
        const yAxisHigh = (Math.ceil(retirementData.monthlySalary / yScale) + 1) * yScale;
        const yAxisTicks = [...Array(Math.ceil(yAxisHigh/yScale))]
            .map((_, i) => i * yScale);

        const xLabels = [...Array(Math.ceil((100 - retirementData.age) / 5))]
            .map((_, i) => (i + Math.floor(retirementData.age / 5)) * 5);

        const incomeSeriesData = [...Array(xLabels.indexOf(defaultRetirementAge) + 1)]
            .map((_, i) => parseFloat(retirementData.monthlySalary));

        const pensionSeriesData = incomeSeriesData
            .slice(1).map(d => undefined).concat(
                [...Array(xLabels.length - xLabels.indexOf(defaultRetirementAge))]
                    .map(
                        (_, i) => {
                            return i < 5 ? round(pensionData.totalPension) : undefined
                        }
                    )
            );

        const pensionNoSavingsSeriesData = incomeSeriesData
            .slice(1).map(d => undefined).concat(
                [...Array(xLabels.length - xLabels.indexOf(defaultRetirementAge))]
                    .map((_, i) => round(pensionData.totalPensionNoSavings))
            );

        dispatch(retirementGuideUpdateChartDataAction({
            pensionData,
            ...retirementData,
            displayData: {
                totalPension: pensionData.totalPension,
                totalPensionNoSavings: pensionData.totalPensionNoSavings,
                totalPublicPension: pensionData.totalPublicPension,
                incomePension: pensionData.incomePension,
                premiumPension: pensionData.premiumPension,
                occupationalPension: pensionData.occupationalPension,
                privateSavingsPension: pensionData.privateSavingsPension,
                monthlySavingsNeeded: pensionData.monthlySavingsNeeded,

                // totalPension: round(pensionData.totalPension, 100, true),
                // totalPensionNoSavings: round(pensionData.totalPensionNoSavings, 100, true),
                // incomePension: round(pensionData.incomePension, 100, true),
                // premiumPension: round(pensionData.premiumPension, 100, true),
                // occupationalPension: round(pensionData.occupationalPension, 100, true),
                // privateSavingsPension: round(pensionData.privateSavingsPension, 100, true),
                // monthlySavingsNeeded: round(pensionData.monthlySavingsNeeded, 10, true),

                // totalPension: round(pensionData.totalPension, 1000, true),
                // totalPensionNoSavings: round(pensionData.totalPensionNoSavings, 1000, true),
                // incomePension: round(pensionData.incomePension, 1000, true),
                // premiumPension: round(pensionData.premiumPension, 1000, true),
                // occupationalPension: round(pensionData.occupationalPension, 1000, true),
                // privateSavingsPension: round(pensionData.privateSavingsPension, 1000, true),
                // monthlySavingsNeeded: round(pensionData.monthlySavingsNeeded, 100, false),

                monthlySalary: round(retirementData.monthlySalary)
            },
            chartSettings: {
                incomeSeries: {
                    name: 'incomeSeries',
                    data: incomeSeriesData
                },
                pensionSeries: {
                    name: 'pensionSeries',
                    data: pensionSeriesData
                },
                pensionNoSavingsSeries: {
                    name: 'pensionNoSavingsSeries',
                    data: pensionNoSavingsSeriesData
                },
                // x-axis labels
                labels: xLabels,
                // y-axis
                axisY: {
                    ticks: yAxisTicks,
                    low: 0,
                    high: yAxisHigh
                }
            }
        }));
    }
}

export function retirementGuideUpdateChartDataAction(chartData) {
    return {
        type: 'RETIREMENT_GUIDE_UPDATE_CHART_DATA',
        chartData
    };
}
